howspace.components.emojiPicker = (() => {
    'use strict';

    const initEmojiMart = async (elem, options = {}) => {
        await lib('emoji-mart', 'browser.js');

        const locale = real.locale.getLanguage();

        const defaultOptions = {
            locale: locale === 'es-419' ? 'es' : locale,
            previewPosition: 'none',
            theme: 'light',
            onEmojiSelect: (emoji) => {
                const parent = elem.closest('.howspace-emoji-picker');
                howspace.dispatchEvent(parent, howspace.components.emojiPicker.EMOJI_PICKED, {
                    emoji: emoji
                });

                closeEmojiPicker(parent);
            },
            onClickOutside: (e) => {
                if (!e.target.classList.contains('emoji-picker-toggle')) {
                    closeEmojiPicker(elem.closest('.howspace-emoji-picker'));
                }
            }
        }

        const pickerOptions = $.extend({}, defaultOptions, options);

        const picker = new EmojiMart.Picker(pickerOptions);
        picker.classList.add('emoji-mart-picker');

        elem.append(picker);
    }

    const openEmojiPicker = (e) => {
        const emojiPicker = $(e.currentTarget.closest('.howspace-emoji-picker'));

        // Close other open emoji pickers
        $('.howspace-emoji-picker.open').each(function () {
            const picker = $(this);
            if (picker[0] !== emojiPicker[0]) {
                closeEmojiPicker(picker);
            }
        });

        if (emojiPicker.is('.open') || emojiPicker.is('.opening') || emojiPicker.is('.closing')) {
            return;
        }

        emojiPicker.removeClass('closed').addClass('open');

        const emojiMartWrapper = emojiPicker.find('.emoji-mart-wrapper');
        emojiMartWrapper.removeClass('d-none');

        if (emojiMartWrapper.attr('inline')) {
            emojiMartWrapper.css('position', 'static');
            emojiMartWrapper.css('display', 'block');
        } else {
            howspace.popover.open(emojiPicker, emojiMartWrapper);
        }
    }

    const closeEmojiPicker = (emojiPicker) => {
        const emojiMartWrapper = emojiPicker.find('.emoji-mart-wrapper');
        emojiPicker.removeClass('open').addClass('closed');

        if (emojiMartWrapper.attr('static')) {
            emojiMartWrapper.css('display', 'none');
        } else {
            emojiMartWrapper.addClass('d-none');
            howspace.popover.close(emojiPicker, emojiMartWrapper);
        }
    }

    const handleKeyDown = e => {
        if (e.key !== 'Escape') {
            return;
        }

        const emojiPicker = $(e.target.closest('.howspace-emoji-picker'));
        if (!emojiPicker.is('.open')) {
            return;
        }

        e.stopImmediatePropagation();
        closeEmojiPicker(emojiPicker);
    };

    const initEmojiPicker = (elem, options = {}) => {
        if (elem.find('.emoji-mart-wrapper').length === 0) {
            return;
        }

        elem.addClass('howspace-emoji-picker-initialized');

        initEmojiMart(elem.find('.emoji-mart-wrapper'), options).then(() => {
            elem.on('click', '.emoji-picker-toggle', (e) => {
                const elem = $(e.currentTarget).closest('.howspace-emoji-picker');
                if (elem.hasClass('closed')) {
                    openEmojiPicker(e);
                } else {
                    closeEmojiPicker(elem);
                }
            });

            elem.on('keydown', handleKeyDown);
        });
    };

    const destroyEmojiPicker = (elem) => {
        elem.removeClass('howspace-emoji-picker-initialized');
        elem.find('.emoji-mart-wrapper').empty();
        elem.find('.emoji-content').empty();
        elem.off('focus click');
    };

    const getEmojiFromNative = (emojiId, callback) => {
        if (typeof EmojiMart.getEmojiDataFromNative !== 'function') {
            return;
        }

        EmojiMart.getEmojiDataFromNative(emojiId).then((result) => {
            if (!result) {
                return;
            }

            if (typeof callback === 'function') {
                callback(result);
            }
        });
    };

    const searchEmoji = async (value, maxResults = null, callback = null) => {
        if (typeof EmojiMart.SearchIndex.search !== 'function') {
            return;
        }

        if (!value) {
            return;
        }

        const searchOptions = {
            maxResults: maxResults || 90 // Default value from EmojiMart is 90
        };

        const emojis = await EmojiMart.SearchIndex.search(value, searchOptions);
        if (emojis.length === 0) {
            return;
        }

        if (typeof callback === 'function') {
            callback(emojis);
        }
    };

    return {
        EMOJI_PICKER_INITIALIZED: 'emoji-picker-initialized',
        EMOJI_PICKER_DESTROYED: 'emoji-picker-destroyed',
        EMOJI_PICKED: 'emoji-picker-picked',
        EMOJI_REMOVED: 'emoji-picker-removed',
        init: (elem, options) => {
            elem.findIncludingSelf('.howspace-emoji-picker:not(.howspace-emoji-picker-initialized)').each(function () {
                initEmojiPicker($(this), options);
            });
        },
        destroy: (elem) => {
            elem.findIncludingSelf('.howspace-emoji-picker.howspace-emoji-picker-initialized').each(function () {
                destroyEmojiPicker($(this));
            });
        },
        getEmojiFromNative: getEmojiFromNative,
        searchEmoji: searchEmoji,
    };
})();
